export default [
    {
        path: '/maintenance',
        meta: {
            title: "Maintenance",
            icon: "maintenance.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "maintenance" */ '../views/admin/page/Maintenance/Index'),
        redirect: { name: 'maintenance' },
        children: [
            {
                path: 'dashboard',
                name: 'maintenance.dashboard',
                meta: {
                    title: "Maintenance Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "maintenance" */ '../views/admin/page/Maintenance/MaintenanceDashboard'),
            },
            {
                path: 'maintenancetracking',
                name: 'maintenancetracking',
                meta: {
                    title: "Maintenance Tracking",
                    show: true
                },
                component: () => import(/* webpackChunkName: "maintenance" */ '../views/admin/page/Maintenance/MaintenanceTracking'),
            },
            {
                path: 'maintenanceorder',
                name: 'maintenance',
                meta: {
                    title: "Maintenance Order",
                    show: true
                },
                component: () => import(/* webpackChunkName: "maintenance" */ '../views/admin/page/Maintenance/MaintenanceOrder'),
            },
            {
                path: 'maintenanceorder/:id',
                name: 'maintenanceorderdetail',
                meta: {
                    title: "Maintenance Order Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "maintenance" */ '../views/admin/page/Maintenance/MaintenanceOrderDetail'),
            },
            {
                path: 'maintenanceorder/:id/:approval',
                name: 'maintenanceorderapproval',
                meta: {
                    title: "Maintenance Order Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "maintenance" */ '../views/admin/page/Maintenance/MaintenanceOrderDetail'),
            },
        ]
    }
]
